<template>
    
    <b-modal id="notifications-modal" title="Notifications" hide-footer>
        <p>New info here</p>
    </b-modal>

</template>

<script>
export default {

    name: 'Notifications',

    data() {
        return {

        }
    }

}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue